export default "__VITE_ASSET__af8b5385__"